module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer006"
    }
  }, [_c('p', {
    staticClass: "centered"
  }, [_c('span', {
    staticClass: "bold _idGenCharOverride-1"
  }, [_vm._v("Also by Basil Sands")])]), _vm._v(" "), _c('p', {
    staticClass: "centered"
  }, [_c('span', {
    staticClass: "italics _idGenCharOverride-1"
  }, [_c('br')])]), _vm._v(" "), _c('p', {
    staticClass: "centered"
  }, [_c('span', {
    staticClass: "italics _idGenCharOverride-1"
  }, [_vm._v("65 Below")])]), _vm._v(" "), _c('p', {
    staticClass: "centered"
  }, [_c('span', {
    staticClass: "italics _idGenCharOverride-1"
  }, [_vm._v("Karl’s Last Flight")])]), _vm._v(" "), _c('p', {
    staticClass: "centered"
  }, [_c('span', {
    staticClass: "italics _idGenCharOverride-1"
  }, [_vm._v("Ice Hammer ")]), _vm._v("series")]), _vm._v(" "), _c('p', {
    staticClass: "centered"
  }, [_c('span', {
    staticClass: "italics _idGenCharOverride-1"
  }, [_vm._v("Invasion")])]), _vm._v(" "), _c('p', {
    staticClass: "centered"
  }, [_c('span', {
    staticClass: "italics _idGenCharOverride-1"
  }, [_vm._v("Insurgent")])]), _vm._v(" "), _c('p', {
    staticClass: "centered"
  }, [_c('span', {
    staticClass: "italics _idGenCharOverride-1"
  }, [_vm._v("Faithful Warrior")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a6540914","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Section0001.vue
// module id = 63
// module chunks = 0